import { Link } from "react-router-dom";
import { PrimaryButton, Overline } from "@/components/site/Primitives";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-[75vh] flex items-center paper-texture">
      <div className="max-w-xl mx-auto px-6 text-center py-24">
        <Overline>Page not found</Overline>
        <h1 className="font-serif text-8xl sm:text-9xl font-light text-brand-olive my-6">404</h1>
        <p className="font-body text-brand-body text-xl leading-relaxed mb-10">
          It seems you've wandered down a lane that leads nowhere, my dear. Let us guide you back to the warmth of the cottage.
        </p>
        <PrimaryButton to="/" testid="notfound-home-btn">Return to Rosewood Cottage</PrimaryButton>
      </div>
    </div>
  );
}
